"use client";
import { useState } from "react";
const faqs = [
    {
        question: "What is neurosurgery?",
        answer: "Neurosurgery is a specialized medical field that focuses on the diagnosis and surgical treatment of disorders related to the brain, spine, and nervous system, including tumors, injuries, and neurological diseases.",
    },
    {
        question: "When should I consult a neurosurgeon?",
        answer: "You should consult a neurosurgeon if you experience symptoms like severe or persistent headaches, seizures, weakness in limbs, back pain, numbness, or after a head or spinal injury.",
    },
    {
        question: "Which is the best hospital for neurosurgery in Patna?",
        answer: "HDNA Aarogyam Hospital is considered one of the best hospitals for neurosurgery in Patna, offering advanced brain and spine treatments with experienced specialists and modern technology.",
    },
    {
        question: "What conditions are treated in neurosurgery?",
        answer: "Neurosurgery covers conditions such as brain tumors, stroke, head injuries, spine disorders (like slip disc), epilepsy, Parkinson’s disease, and congenital brain or spinal problems.",
    },
    {
        question: "Is brain surgery safe?",
        answer: "Yes, brain surgery is generally safe when performed by experienced neurosurgeons using advanced technology. The success rate depends on the patient’s condition, type of surgery, and timely treatment.",
    },
    {
        question: "What is the cost of neurosurgery in Patna?",
        answer: "The cost of neurosurgery in Patna varies depending on the type of procedure, complexity, hospital facilities, and patient condition. It is best to consult the hospital for an accurate estimate.",
    },
    {
        question: "How long does it take to recover from neurosurgery?",
        answer: "Recovery time depends on the type of surgery and the patient’s overall health. It can range from a few weeks to several months, with proper post-operative care and rehabilitation.",
    },
    {
        question: "What is minimally invasive neurosurgery?",
        answer: "Minimally invasive neurosurgery involves performing procedures using smaller incisions, advanced tools, and imaging techniques. It results in less pain, faster recovery, and reduced hospital stay.",
    },
    {
        question: "Do you provide emergency neurosurgery services in Patna?",
        answer: "Yes, HDNA Aarogyam Hospital offers 24×7 emergency neurosurgery services for conditions like stroke, head injuries, and brain hemorrhage.",
    },
    {
        question: "How can I book an appointment with a neurosurgeon in Patna?",
        answer: "You can book an appointment by calling the hospital directly, visiting the website, or walking into HDNA Aarogyam Hospital for consultation with a neurosurgery specialist.",
    }
];
export default function FaqSection() {
    const [activeIndex, setActiveIndex] = useState(null);
    const leftFaqs = faqs.slice(0, 5);
    const rightFaqs = faqs.slice(5, 10);
    const toggleFaq = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const renderFaqs = (faqList, offset) =>
        faqList.map((faq, index) => {
            const currentIndex = index + offset;
            return (
                <div key={currentIndex} className="faq-box" onClick={() => toggleFaq(currentIndex)} >
                    {/* Question */}
                    <div className={`faq-question ${activeIndex === currentIndex ? "active" : ""}`}>
                        <h6>{faq.question}</h6>
                        <span className="icon"> {activeIndex === currentIndex ? "−" : "+"}</span>
                    </div>
                    {/* Answer */}
                    {activeIndex === currentIndex && (
                        <div className="faq-answer"> <p>{faq.answer}</p> </div>
                    )}
                </div>
            );
        });

    return (
        <section className="faq-section container">
            <div className="row">
                {/* Left Column */}
                <div className="col-lg-6">{renderFaqs(leftFaqs, 0)}</div>
                {/* Right Column */}
                <div className="col-lg-6">{renderFaqs(rightFaqs, 5)}</div>
            </div>
        </section>
    );
}
